<template>
  <!-- eslint-disable -->
  <div>
    <inventario-add :is-add.sync="isAdd" @saved="submitMove" />
    <b-overlay variant="white" :show="loading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Marca</label>
              <b-form-input v-model="filters.brand" placeholder="Marca" @keyup.enter="search" />
            </b-col>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Codigo</label>
              <b-form-input v-model="filters.code" placeholder="Codigo" @keyup.enter="search" />
            </b-col>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Fila</label>
              <b-form-input v-model="filters.fila" placeholder="Fila" @keyup.enter="search" />
            </b-col>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Bloque</label>
              <b-form-input v-model="filters.bloque" placeholder="Bloque" @keyup.enter="search" />
            </b-col>
            <b-col md="4" class="mt-2">
              <b-button variant="secondary" class="mr-1" @click.prevent="cleanFilters">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span class="align-middle">Limpiar</span>
              </b-button>
              <b-button variant="primary" @click.prevent="search">
                <feather-icon icon="SearchIcon" class="mr-50" />
                <span class="align-middle">Buscar</span>
              </b-button>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-end">
              <b-button variant="primary" class="mt-2" @click="openAdd">
                <feather-icon icon="PlusIcon" class="mr-50" />
                Agregar
              </b-button>
              <b-button variant="success" class="mt-2 ml-1" @click="openUploader">
                <feather-icon icon="UploadCloudIcon" class="mr-50" />
                Subir Excel
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mt-2 mb-0">
        <b-card-header>
          <b-card-title>Stock en inventario</b-card-title>
        </b-card-header>
        <b-table
          class="position-relative"
          :hover="true"
          :items="inventoryStock"
          responsive
          :fields="stockFields"
          show-empty
          empty-text="No existe stock en inventario"
        >
          <template #cell(user)="data">
            <span>{{ getUserName(data.item.user) }}</span>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="inventory-input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span>{{ totalElements }} Registros en total</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-modal id="inventory-excel-modal" title="Subir Excel a inventario" hide-footer centered>
      <b-form-group label="Almacen" label-for="excel-warehouse">
        <b-form-input id="excel-warehouse" v-model="excelForm.warehouse" placeholder="ALMACEN" />
      </b-form-group>

      <b-form-group label="Fila" label-for="excel-fila">
        <b-form-input id="excel-fila" v-model="excelForm.fila" placeholder="FILA-A" />
      </b-form-group>

      <b-form-group label="Bloque" label-for="excel-bloque">
        <b-form-input id="excel-bloque" v-model="excelForm.bloque" placeholder="BLOQUE-1" />
      </b-form-group>

      <b-form-group label="Excel" label-for="excel-file">
        <b-form-file
          id="excel-file"
          v-model="excelForm.file"
          accept=".xls,.xlsx"
          browse-text="Elegir archivo"
          placeholder="Selecciona un archivo Excel"
          @input="validateFile"
        />
        <small class="text-muted d-block mt-1">
          Archivo permitido: .xls o .xlsx
        </small>
      </b-form-group>

      <div class="d-flex flex-wrap justify-content-between align-items-center mt-2">
        <b-button variant="outline-primary" class="mb-50 mb-sm-0" @click="downloadTemplate">
          <feather-icon icon="DownloadIcon" class="mr-50" />
          Descargar formato
        </b-button>
        <div class="text-right">
          <b-button variant="outline-secondary" class="mr-50" @click="$bvModal.hide('inventory-excel-modal')">
            Cancelar
          </b-button>
          <b-button :disabled="!canUploadExcel || uploading" variant="primary" @click="submitUploadExcel">
            <b-spinner v-if="uploading" small class="mr-50" />
            Subir
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ContainerService from '@/services/ContainerService'
import inventarioAdd from './inventarioAdd.vue'
import * as XLSX from 'xlsx'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    inventarioAdd,
  },
  data() {
    return {
      loading: false,
      saving: false,
      uploading: false,
      isAdd: false,
      inventoryStock: [],
      totalElements: 0,
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      sort: 'id',
      order: 'desc',
      filterTimer: null,
      validFile: false,
      excelForm: {
        warehouse: '',
        fila: '',
        bloque: '',
        file: null,
      },
      filters: {
        brand: '',
        code: '',
        fila: '',
        bloque: '',
      },
      stockFields: [
        { key: 'warehouse', label: 'ALMACEN', sortable: false },
        { key: 'brand', label: 'MARCA', sortable: false },
        { key: 'code', label: 'CODIGO', sortable: false },
        { key: 'totalQuantity', label: 'CANTIDAD', sortable: false },
        { key: 'rowName', label: 'FILA', sortable: false },
        { key: 'blockName', label: 'BLOQUE', sortable: false },
        { key: 'user', label: 'USUARIO', sortable: false },
      ],
    }
  },
  mounted() {
    this.getInventoryStock()
  },
  computed: {
    canUploadExcel() {
      return this.validFile && this.excelForm.warehouse !== '' && this.excelForm.fila !== '' && this.excelForm.bloque !== ''
    },
  },
  methods: {
    normalizeRows(data) {
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.rows)) return data.rows
      if (data && Array.isArray(data.data)) return data.data
      if (data && data.data && Array.isArray(data.data.data)) return data.data.data
      if (data && data.data && Array.isArray(data.data.rows)) return data.data.rows
      return []
    },
    normalizeTotal(data, rows) {
      if (data && data.count !== undefined) return data.count
      if (data && data.total !== undefined) return data.total
      if (data && data.totalElements !== undefined) return data.totalElements
      if (data && data.responseFilter && data.responseFilter.total_rows !== undefined) return data.responseFilter.total_rows
      if (data && data.data && data.data.responseFilter && data.data.responseFilter.total_rows !== undefined) return data.data.responseFilter.total_rows
      return rows.length
    },
    openAdd() {
      this.isAdd = true
    },
    openUploader() {
      this.excelForm = {
        warehouse: '',
        fila: '',
        bloque: '',
        file: null,
      }
      this.validFile = false
      this.uploading = false
      this.$bvModal.show('inventory-excel-modal')
    },
    validateFile(file) {
      this.validFile = !!file && /\.(xls|xlsx)$/i.test(file.name)
    },
    downloadTemplate() {
      const headers = ['MARCA', 'CODIGO', 'QTY']
      const worksheet = XLSX.utils.aoa_to_sheet([headers])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Formato')
      XLSX.writeFile(workbook, 'formato_inventario.xlsx')
    },
    buildBackendFilters() {
      const arrayFilters = []

      if (this.filters.brand !== '') {
        arrayFilters.push({
          keyContains: 'brand',
          key: 'contains',
          value: this.filters.brand,
        })
      }

      if (this.filters.code !== '') {
        arrayFilters.push({
          keyContains: 'code',
          key: 'contains',
          value: this.filters.code,
        })
      }

      if (this.filters.fila !== '') {
        arrayFilters.push({
          keyContains: 'rowName',
          key: 'contains',
          value: this.filters.fila,
        })
      }

      if (this.filters.bloque !== '') {
        arrayFilters.push({
          keyContains: 'blockName',
          key: 'contains',
          value: this.filters.bloque,
        })
      }

      return arrayFilters
    },
    filterData() {
      this.currentPage = 1
      clearTimeout(this.filterTimer)
      this.filterTimer = setTimeout(() => {
        this.getInventoryStock()
      }, 350)
    },
    // NUEVO MÉTODO: ejecuta la búsqueda con los filtros actuales
    search() {
      this.currentPage = 1
      this.getInventoryStock()
    },
    cleanFilters() {
      this.filters = {
        brand: '',
        code: '',
        fila: '',
        bloque: '',
      }
      this.currentPage = 1
      this.getInventoryStock()
    },
    cambioPagina(page) {
      this.currentPage = page
      this.getInventoryStock()
    },
    changeSizePage() {
      this.currentPage = 1
      this.getInventoryStock()
    },
    responseMessage(resp, fallback) {
      return (resp && resp.message) || (resp && resp.data && resp.data.message) || fallback
    },
    responseHasError(resp) {
      return (resp && resp.error === true) || (resp && resp.data && resp.data.error === true)
    },
    getUserName(user) {
      if (!user) return ''
      return user.fullname || user.name || user.email || ''
    },
    async getInventoryStock() {
      this.inventoryStock = []
      this.totalElements = 0
      this.loading = true
      const arrayFilters = this.buildBackendFilters()
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(arrayFilters)}`
      const resp = await ContainerService.getInventoryStock(url, this.$store)
      if (resp) {
        this.inventoryStock = this.normalizeRows(resp)
        this.totalElements = this.normalizeTotal(resp, this.inventoryStock)
      }
      this.loading = false
    },
    async submitMove(payload) {
      this.saving = true
      this.loading = true
      const resp = await ContainerService.moveToInventory(payload, this.$store)
      this.saving = false
      this.loading = false

      if (resp && !this.responseHasError(resp)) {
        const message = this.responseMessage(resp, 'El contenedor fue movido a inventario correctamente.')
        this.$swal({
          title: 'Movido a inventario',
          text: message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(() => {
          this.getInventoryStock()
        })
      } else {
        const message = this.responseMessage(resp, 'Hubo un error al mover el contenedor a inventario.')
        this.$swal({
          title: 'Error!',
          text: message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
    async submitUploadExcel() {
      if (!this.canUploadExcel || this.uploading) return

      this.uploading = true
      const resp = await ContainerService.moveToInventoryExcel(
        this.excelForm.file,
        String(this.excelForm.warehouse).trim(),
        String(this.excelForm.fila).trim(),
        String(this.excelForm.bloque).trim(),
        this.$store,
      )
      this.uploading = false

      if (resp && !this.responseHasError(resp)) {
        const message = this.responseMessage(resp, 'El Excel fue procesado correctamente.')
        this.$bvModal.hide('inventory-excel-modal')
        this.$swal({
          title: 'Excel subido',
          text: message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(() => {
          this.getInventoryStock()
        })
      } else {
        const message = this.responseMessage(resp, 'Hubo un error al subir el Excel.')
        this.$swal({
          title: 'Error!',
          text: message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
  },
}
</script>
